module.exports = __webpack_public_path__ + "static/media/edit-icon.1c61dc67.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/edit-icon.svg
// module id = 254
// module chunks = 0